module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[58]179.62011f3.woff2";